import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatComposeFormComponent } from './cat-compose-form/cat-compose-form.component';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'form' },
  { path: 'form', component: CatComposeFormComponent },
  { path: 'order-confirmation/:id', component: OrderConfirmationDetailsComponent },
  { path: 'order-confirmation/bulk/:id', component: OrderConfirmationDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CatComposeRoutingModule {}
